var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-wrapper"},[_c('div',{staticClass:"printable-area"},[_vm._t("default")],2),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.print()}}},[_vm._v("\n    Print\n    "),_c('font-awesome-icon',{attrs:{"prefix":"","icon":['fas', 'print'],"size":"2x"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64fbcbbf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Print.vue
// module id = null
// module chunks = 